import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';

import reportWebVitals from './reportWebVitals';
import './i18n.js'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './redux/store.js'; // Import your Redux store


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);


reportWebVitals();
